<div class="header">
    <div class="header-section">
        <img *ngIf="modalConfig?.modalIconTitle" class="title-icon" [src]="modalConfig.modalIconTitle" alt="">
        <span class="header-title">{{ modalConfig.modalTitle }}</span>
    </div>
    <button type="button" class="close"
        *ngIf="modalConfig.hideCloseButton === undefined  || !modalConfig.hideCloseButton()"
        [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
        <img src="assets/icons/close.svg" alt="X" (click)="close()">
    </button>
</div>
<div class="modal-body">
    <ng-content></ng-content>
</div>